import api from '../../common/api';

export const apiSend = (text) => api.pikApi.fetch('POST', '/v1/recourse/feedback', {
  token: '6809a8ab-8f7e-4663-995f-5756bb10bc55',
  chat_id_field: 'telegram_bot_investing_chat_id',
  text,
});
